import { useEffect, useState } from "react";
import { RoomEvent, type MatrixClient, type Room } from "matrix-js-sdk";
import { getRoomReactions, type ReactionsByEvent } from "./reactions";

/**
 * Subscribes to a room's reaction annotations and re-aggregates them live as
 * reactions are added (Timeline) or removed (Redaction).
 */
export function useReactions(client: MatrixClient, room: Room): ReactionsByEvent {
  const [reactions, setReactions] = useState<ReactionsByEvent>(() =>
    getRoomReactions(client, room),
  );

  useEffect(() => {
    const refresh = (_event?: unknown, eventRoom?: Room) => {
      if (eventRoom && eventRoom.roomId !== room.roomId) return;
      setReactions(getRoomReactions(client, room));
    };

    refresh();
    client.on(RoomEvent.Timeline, refresh);
    client.on(RoomEvent.Redaction, refresh);
    return () => {
      client.removeListener(RoomEvent.Timeline, refresh);
      client.removeListener(RoomEvent.Redaction, refresh);
    };
  }, [client, room]);

  return reactions;
}
